<template>
  <router-link :to="{ name: pathName }" tag="li" v-if="!hasSubGroup" :class="childClass">
    <a>{{ text }}</a>
  </router-link>
  <li v-else :class="cssClass" :id="childClass">
    <a @click="toggleIsActive()">{{ text }}</a>
    <ul>
      <li v-for="item in items">
        <router-link :to="{ name: item.pathName }" tag="li">
          <a>{{ item.text }}</a>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'nav-list-item',
  props: {
    text: {
      type: String
    },
    pathName: {
      type: String
    },
    icon: {
      type: String
    },
    hasSubGroup: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    childClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    toggleIsActive() {
      this.isActive = !this.isActive
    }
  },
  computed: {
    cssClass() {
      return this.childClass + ' ' + (this.isActive ? 'active' : '') + ' ' + (this.hasSubGroup ? 'has_subpages' : '')
    }
  },
  mounted() {
    const parent = document.getElementById(this.childClass)
    if (parent) {
      if (document.getElementById(this.childClass).querySelectorAll('.active').length > 0) {
        this.isActive = true
      }
    }
  }
}
</script>
